module.exports = __webpack_public_path__ + "static/fonts/iconfont.22e424a0.woff";